<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="인원관리" device="web" :IsUseSearchRequirement="true">
        <template v-slot:SearchRequirement>
          <v-radio-group v-model="delYn" row>
            <v-radio color="radio" v-for="(item, value) in delYnList" :key="value" :label="item.text" :v-model="item.value"></v-radio>
          </v-radio-group>
        </template>
        <template v-slot:body>
          <DxDataGrid
            id="hrDataGrid"
            class="layout-col-height00"
            :ref="dxDataGridRef"
            :data-source="gridMain"
            :remote-operations="false"
            :hover-state-enabled="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-row-lines="true"
            :focused-row-enabled="true"
            key-expr="id"
            @row-updating="onRowUpdating"
            @editor-preparing="onEditorPreparing"
          >
            <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

            <DxColumn
              data-field="save"
              data-type="string"
              width="120px"
              alignment="center"
              caption
              :allow-editing="false"
              cell-template="actionTemplete"
            ></DxColumn>
            <template #actionTemplete="{ data: cellInfo }">
              <div>
                <v-btn color="primary" elevation="0" dark small @click="btnDetail(cellInfo)" class="rounded px-3 grid-btn">상세보기</v-btn>
              </div>
            </template>

            <DxColumn
              data-field="clntNm"
              caption="회사명"
              width="200px"
              data-type="string"
              alignment="center"
              css-class="devest-grid-header-require"
              :allow-editing="false"
            ></DxColumn>
            <DxColumn
              data-field="korNm"
              caption="성명"
              width="100px"
              data-type="string"
              alignment="center"
              css-class="devest-grid-header-require"
              :allow-editing="false"
            ></DxColumn>
            <DxColumn
              data-field="userCd"
              caption="아이디"
              width="200px"
              data-type="string"
              alignment="center"
              css-class="devest-grid-header-require"
              :allow-editing="false"
            ></DxColumn>

            <DxColumn data-field="jbrp" caption="직책/직위" width="120px" data-type="string" alignment="center" :allow-editing="false">
              <DxLookup :data-source="jbrpList" value-expr="minorCd" display-expr="minorNm" />
            </DxColumn>

            <DxColumn
              data-field="companyGroup"
              caption="사업장 그룹"
              width="300px"
              data-type="string"
              alignment="left"
              cell-template="companyGroupDisplay"
              edit-cell-template="companyGroupEditor"
              :calculate-filter-expression="companyGroupFilterExpression"
            />
            <template #companyGroupDisplay="{ data: cellInfo }">
              <span class="company-group-text">{{ getCompanyGroupDisplayText(cellInfo.value) }}</span>
            </template>
            <template #companyGroupEditor="{ data: cellInfo }">
              <v-autocomplete
                item-text="compNm"
                item-value="key"
                :menu-props="{ offsetY: false }"
                :items="companyGroupList"
                rounded
                chips
                deletable-chips
                multiple
                :filter="filterCompanyGroup"
                :search-input.sync="companyGroupSearch"
                dense
                density
                :value="cellInfo.value !== null ? cellInfo.value.split(',') : ''"
                @change="onCompanyGroupValueChanged($event, cellInfo)"
              >
                <template v-slot:prepend-item>
                  <!-- <v-sheet class="px-4 pt-4 pb-2">
                    <v-text-field
                      v-model="companyGroupSearch"
                      dense
                      hide-details
                      placeholder="검색어를 입력하세요"
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      @click:clear="companyGroupSearch = ''"
                    ></v-text-field>
                  </v-sheet> -->
                  <v-divider></v-divider>
                  <v-list-item class="company-group-item">
                    <v-list-item-content>
                      <div class="company-group-grid header">
                        <span>고객사명</span>
                        <span>주소</span>
                        <span>사업장(공사)명</span>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 2" close @click.close="item = false" style="overflow: initial">{{ item.compNm }}</v-chip>
                  <span v-if="index === 2" class="text-grey text-caption align-self-center">(+α)</span>
                </template>
                <template v-slot:item="{ item, attrs, on }">
                  <v-list-item v-bind="attrs" v-on="on" dense class="company-group-item">
                    <v-list-item-content>
                      <div class="company-group-grid">
                        <span class="ellipsis">{{ item.clntNm }}</span>
                        <span class="ellipsis">{{ item.addrs1 }}</span>
                        <span class="ellipsis">{{ item.compNm }}</span>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </template>

            <DxColumn data-field="groupAuth" data-type="string" width="180px" alignment="center" caption="권한그룹" :allow-editing="false">
              <DxLookup :data-source="groupAuthDataSource" value-expr="grpAuthCd" display-expr="grpAuthNm" />
            </DxColumn>

            <DxColumn
              data-field="useYn"
              caption="사용"
              width="100px"
              data-type="string"
              alignment="center"
              edit-cell-template="checkBoxEditor"
              :showEditorAlways="true"
            />
            <template #checkBoxEditor="{ data: cellInfo }">
              <div>
                <DxCheckBox :value="cellInfo.value === 'Y' ? true : false" :onValueChanged="(event) => onCheckValueChanged(event, cellInfo)" />
              </div>
            </template>

            <DxColumn data-field="remark" caption="비고" data-type="string" alignment="left" :allow-editing="false" />
          </DxDataGrid>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer v-model="procedureShow" width="75%" absolute right temporary class="feedback-area">
            <ProcedureComponent :type="'00004'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap" :class="{ 'guide-highlight-add': guideHighlightAdd }">
        <!-- 고도화때 사용 (임시주석) -->
        <!-- <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'검색조건'" height="72px" :icon="'filter_condition'" @click="btnFilter()">
              <i-search-filter v-if="showSearchPanel">
                <template v-slot:filters>
                  <v-radio-group v-model="delYn" row>
                    <v-radio color="radio" v-for="(item, value) in delYnList" :key="value" :label="item.text" :v-model="item.value"></v-radio>
                  </v-radio-group>
                  <v-select solo class="editor_bg"></v-select>
                  <v-select solo class="editor_bg"></v-select>
                  <div class="dateFilter">
                    <i-date-time-picker
                      placeholder="시작일자"
                      :dateOnly="true"
                      :menu="true"
                      :min-width="100"
                      @getDate="setSearchDate($event, 'start')"
                    ></i-date-time-picker>
                    <span class="mx-2">~</span>
                    <i-date-time-picker
                      placeholder="종료일자"
                      :dateOnly="true"
                      :menu="true"
                      @getDate="setSearchDate($event, 'end')"
                    ></i-date-time-picker>
                  </div>
                  <v-select solo class="editor_bg"></v-select>
                  <v-text-field solo class="editor_bg my-3" placeholder="검색어를 입력해주세요">
                    <template v-slot:append>
                      <svg-icon style="width: 16px; color:#B4B4B4; margin-right: 2px" icon-class="table-search"></svg-icon>
                    </template>
                  </v-text-field>
                </template>
                <template v-slot:buttons>
                  <v-btn color="primary" text depressed class="px-5" @click="showSearchPanel = false">취소</v-btn>
                  <v-btn color="primary" depressed class="px-5" @click="showSearchPanel = false">조회</v-btn>
                </template>
              </i-search-filter>
            </i-icon-button>
          </template>
        </i-card-right>-->
        <i-card-right
          headerTitle
          :useBtnList="buttonUseList"
          @btnSearch="btnSearch()"
          @btnAdd="btnAdd()"
          @btnSave="btnSave()"
          @btnDelete="btnDelete()"
        ></i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              class="guide-download-btn"
              color="btn_text"
              :text="'양식 다운로드'"
              :icon="'download'"
              @click="btnDownload"
            ></i-icon-button>
            <i-icon-button color="btn_text" :text="'엑셀 업로드'" :icon="'upload'" @click="btnUpload"></i-icon-button>
            <i-icon-button color="btn_text" :text="'절차서'" :icon="'file'" @click="procedureShow = !procedureShow"></i-icon-button>
            <input ref="templateFile" type="file" class="d-none" accept=".xlsx" @change="handleFileUpload" />
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
import {
  saveHrManageList,
  deleteHrManage,
  getCompanyGroup,
  getHrManage,
  getHrManageFormTemplate,
  saveHrManageFormTemplate,
} from '@/api/baseManage/esgHRManage'
import { getCommonCode } from '@/api/common/commonApi'
import { getGroupData } from '@/api/setting/groupManage'
import { downloadFile, getFile } from '@/api/baseManage/fileUpload'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import baseview from '@/views/base/baseview.vue'
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import { AesDecrypt, AesEncrypt } from '@/utils/aes256' //cyrptojs 적용(aes256)
import { getGrpAuthCd } from '@/utils/token'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'
import { getDuplicateConfirm } from '@/api/system/userManage'

import * as XLSX from 'xlsx'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    // 절차서 컴포넌트
    ProcedureComponent,
  },
  data() {
    return {
      dxDataGridRef: 'hrDataGrid',
      gridMain: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave', //저장
        'btnDelete', //삭제
      ],
      jbrpList: [],
      companyGroupList: [],
      companyGroupNames: new Map(),
      groupAuthDataSource: [],
      korNm: '',
      delYn: 0,
      compId: null,
      delYnList: [
        { text: '사용', value: '0' },
        { text: '미사용', value: '1' },
      ],
      clntId: '',
      showSearchPanel: false,
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false, // 절차서 보이기

      companyGroupSearch: '',
      guideHighlightAdd: false, // 안전보건관리체계 구축 진행도 이동 시 추가/양식 다운로드 버튼 깜빡임
      _guideHighlightTimer: null,
    }
  },
  beforeMount() {},
  mounted() {
    this.clntId = this.getClntId()
    this.applyGuideHighlightFromRoute()
  },
  activated() {
    if (this.$route.params?.data?.guideHighlight) {
      this.applyGuideHighlightFromRoute()
    }
    this.btnSearch()
    this.setComboBoxData()
  },
  beforeDestroy() {
    if (this._guideHighlightTimer) {
      clearTimeout(this._guideHighlightTimer)
      this._guideHighlightTimer = null
    }
  },
  watch: {
    delYn() {
      this.btnSearch()
    },
    // 안전보건관리체계 구축 진행도에서 같은 경로로 재이동할 때(query._t) 가이드 하이라이트 재적용
    '$route.query._t'(val, oldVal) {
      if (val && oldVal && val !== oldVal) {
        this.applyGuideHighlightFromRoute()
      }
    },
  },
  methods: {
    // 안전보건관리체계 구축 진행도에서 진입 시 추가·양식 다운로드 버튼을 붉게 깜빡여 안내
    applyGuideHighlightFromRoute() {
      const routeData = this.$route.params && this.$route.params.data
      if (!routeData || !routeData.guideHighlight) return

      if (this._guideHighlightTimer) {
        clearTimeout(this._guideHighlightTimer)
        this._guideHighlightTimer = null
      }
      this.guideHighlightAdd = false
      this.$nextTick(() => {
        this.guideHighlightAdd = true
        this._guideHighlightTimer = setTimeout(() => {
          this.guideHighlightAdd = false
          this._guideHighlightTimer = null
        }, 5000)
      })
    },
    async btnDelete() {
      const selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      this.vToastifyPrompt(this.$t('삭제하시겠습니까?'), 'info', (current) => {
        this.openLoading()
        deleteHrManage(selectedRows, true)
          .then((res) => {
            if (res.success) {
              this.btnSearch()
            }
          })
          .catch((error) => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      })
    },
    btnDownload() {
      this.vToastifyPrompt(
        this.$t('양식을 다운로드하시겠습니까?'),
        'info',
        (current) => {
          this.openLoading()
          const params = {
            clntId: 'IGNS',
            targetId: '99996',
            targetType: 'CF001',
          }
          getHrManageFormTemplate(params)
            .then((res) => {
              this.endLoading()
              this.downloadReport(res, '인원관리 양식.xlsx')
            })
            .catch((error) => {
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    btnUpload() {
      this.$refs.templateFile.click()
    },
    handleFileUpload(e) {
      const file = e.target.files[0]
      let inputData = null
      let datasetData = null
      if (file) {
        const reader = new FileReader()

        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, { type: 'array' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          let jsonData = XLSX.utils.sheet_to_json(worksheet, {
            header: 1, // 첫 번째 행을 헤더로 사용
            defval: '', // 빈 셀에 빈 문자열을 기본값으로 설정
            blankRows: false, // 빈 행을 제외
          })
          const dataSetSheetName = workbook.SheetNames[1]
          const dataSetWorksheet = workbook.Sheets[dataSetSheetName]
          let dataSetJsonData = XLSX.utils.sheet_to_json(dataSetWorksheet, {
            header: 1, // 첫 번째 행을 헤더로 사용
            defval: '', // 빈 셀에 빈 문자열을 기본값으로 설정
            blankRows: false, // 빈 행을 제외
          })

          // 빈 행을 제거
          jsonData = jsonData.filter((row) => row.some((cell) => cell !== ''))
          dataSetJsonData = dataSetJsonData.filter((row) => row.some((cell) => cell !== ''))

          // 첫 번째 행(헤더), 두 번째 행(예시)을 제외하고 excelData에 바인딩
          inputData = jsonData.slice(2)
          datasetData = dataSetJsonData.slice(2)
        }

        reader.readAsArrayBuffer(file)
        e.target.value = null // 이벤트를 다시 받을 수 있도록 초기화
        //엑셀 데이터 저장
        this.vToastifyPrompt(
          this.$t('doSaveData'),
          'info',
          //yes action
          (current) => {
            console.log('#datasetData', datasetData)
            console.log('#inputData', inputData)
            this.saveExcelData(inputData, datasetData)
          },
          null,
          true
        )
      }
    },
    saveExcelData(inputData, datasetData) {
      if (inputData == null || inputData.length === 0) {
        this.vSnackbar(this.$t('selectionData'), 'warning')
        return
      }
      const invalidItems = inputData.filter((item) => {
        // 필수값 체크
        if (item[1] === null || item[1] === '') return item // 이름
        if (item[2] === null || item[2] === '') return item // 전화번호
        if (item[3] === null || item[3] === '') return item // 아이디
        if (item[4] === null || item[4] === '') return item // 권한 그룹
        if (item[5] === null || item[5] === '') return item // 사업장 그룹
      })
      if (invalidItems.length > 0) {
        this.vSnackbar(this.$t('필수값이 누락되었습니다.'), 'warning')
        return
      }
      // 엑셀데이터 인덱스 목록
      const indexData = {
        korNm: 1, // 이름
        hpNo: 2, // 전화번호
        userCd: 3, // 아이디
        grpAuthNm: 4, // 권한그룹명
        companyGroupList: 5, // 사업장 리스트
      }
      for (const item of inputData) {
        getDuplicateConfirm({ userCd: item[indexData.userCd]?.replace(/\s/g, '') }).then((res) => {
          if (res.list !== undefined) {
            this.vSnackbar(this.$t(`${item[indexData.userCd]} 는 이미 사용중인 아이디입니다.`), 'warning')
            return
          }
        })
      }
      // grpAuthCdMap: 3번지=코드값, 4번지=코드명
      const grpAuthCdMap = new Map()
      datasetData.forEach((row) => {
        if (row[3] && row[4]) {
          grpAuthCdMap.set(row[4], row[3])
        }
      })

      // compMap: 6번지=코드값, 7번지=코드명
      const compMap = new Map()
      datasetData.forEach((row) => {
        // 코드값(6번지)와 코드명(7번지) 모두 있는 경우만 추가
        if (row[6] && row[7]) {
          // row[6] 값에서 양쪽에 붙은 따옴표(") 제거 ('"IGNS_COMMON"' → IGNS_COMMON)
          const code = row[7].replace(/^"|"$/g, '')
          compMap.set(code.replace(/\s/g, ''), row[6])
        }
      })
      const datasetGrpMap = new Map()
      datasetData.forEach((row, index) => {
        datasetGrpMap.set(row[index][3], row[index][4])
      })
      let saveData = []
      inputData.forEach((row) => {
        const param = {
          korNm: row[indexData.korNm]?.replace(/\s/g, ''),
          hpNo: row[indexData.hpNo]?.replace(/\s/g, '').replaceAll('-', ''),
          userCd: row[indexData.userCd]?.replace(/\s/g, ''),
          grpAuthCd: grpAuthCdMap.has(row[indexData.grpAuthNm]) ? grpAuthCdMap.get(row[indexData.grpAuthNm]) : null,
          companyGroupList:
            row[indexData.companyGroupList]?.replace(/\s/g, '') === ''
              ? []
              : row[indexData.companyGroupList]
                  .replace(/\s/g, '')
                  .split(',')
                  .map((code) => (compMap.has(code) ? compMap.get(code) : null))
                  .filter((code) => code),
          userPs: AesEncrypt(row[indexData.hpNo]?.replace(/\s/g, '').slice(-8)),
          useYn: 'Y',
          delYn: 'N',
          __created__: true,
        }
        saveData.push(param)
      })
      // console.log('##inputData', saveData)
      this.openLoading()
      saveHrManageFormTemplate(saveData, true)
        .then((res) => {
          this.btnSearch()
        })
        .catch((error) => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnFilter() {
      this.showSearchPanel = !this.showSearchPanel
    },
    async btnDetail(cellInfo) {
      const toRouter = {
        name: 'EsgHRManageDetail',
        params: {
          data: cellInfo.data,
        },
      }
      this.$router.push(toRouter)
    },
    displayJoinCell(occanCuases) {
      if (!occanCuases) return ''
      let occanCuaseList = occanCuases.split(',')
      let resultArray = []
      occanCuaseList.forEach((element) => {
        if (this.companyGroupList) {
          let data = this.companyGroupList.find((company) => company.compId == element).compNm
          resultArray.push(data)
        }
      })
      return resultArray.join(', ')
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    btnAdd() {
      let data = {}
      Object.defineProperty(data, '__created__', {
        value: true,
        writable: true,
        enumerable: true,
        configurable: true,
      })

      const toRouter = {
        name: 'EsgHRManageDetail',
        params: {
          data: data,
        },
      }
      this.$router.push(toRouter)
    },
    btnSearch() {
      const grpAuthCd = getGrpAuthCd()
      if (grpAuthCd === 'master' || grpAuthCd === 'kiest_admin') {
        this.clntId = this.getClntId()
      }

      this.gridInit(this.GetDataGrid(this.dxDataGridRef))
      this.openLoading('searching')

      let searchParams = { korNm: this.korNm, riskAssRole: this.riskAssRole, clntId: this.clntId, delYn: this.delYn }
      getHrManage(searchParams, true)
        .then((res) => {
          this.gridInit(this.GetDataGrid(this.dxDataGridRef))
          this.gridMain = []
          this.gridMain = res.list
          this.enrichCompanyGroupDisplay()
          this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
        })
        .finally(() => {
          this.endLoading()
        })
    },
    async btnSave() {
      var selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      // console.log('@@@@', this.editingData)
      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        //yes action
        (current) => {
          this.GetDataGrid(this.dxDataGridRef).beginUpdate()
          this.GetDataGrid(this.dxDataGridRef).saveEditData()

          this.openLoading('saving')

          selectedRows.forEach((row) => {
            if (typeof row.useYn == Boolean) row.useYn == true ? (row.useYn = 'Y') : (row.useYn = 'N')
            if (row.companyGroup != '' && row.companyGroup != undefined) {
              row.companyGroupList = row.companyGroup.split(',')
            }
          })

          saveHrManageList(selectedRows, true)
            .then((res) => {
              if (res.success) {
                //
              }
            })
            .finally(() => {
              this.GetDataGrid(this.dxDataGridRef).endUpdate()
              this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
              this.endLoading()
              this.btnSearch()
            })
        },
        null,
        true
      )
    },
    ///////////////////////////////////////
    /*        DataGrid Event Event       */
    ///////////////////////////////////////
    gridInit() {
      this.GetDataGrid(this.dxDataGridRef).clearSelection()
      this.GetDataGrid(this.dxDataGridRef).option('focusedRowIndex', -1)
      this.GetDataGrid(this.dxDataGridRef).cancelEditData()
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    saveCallBack(selectedRows) {
      var index = null
      selectedRows.forEach((key) => {
        index = this.gridMain.findIndex((obj) => obj == key)
        this.gridMain.splice(index, 1)
      })
    },
    setComboBoxData() {
      const grpAuthCd = getGrpAuthCd()
      if (grpAuthCd === 'master' || grpAuthCd === 'kiest_admin') {
        this.clntId = this.getClntId()
      }
      const params = { clntId: this.clntId }

      Promise.all([getCommonCode('CM007'), getCommonCode('CM006'), getGroupData(), getCompanyGroup(params)]).then((response) => {
        let failedResponse = response.find((element) => !element.success)
        if (failedResponse == null) {
          //	직책/직위
          this.jbrpList = response[0].list.slice()
          this.jbrpList.unshift({ minorCd: '', minorNm: '' })

          // 권한그룹
          this.groupAuthList = response[2].list.slice()
          this.groupAuthDataSource = this.groupAuthList.filter((element) => element.grpAuthCd)

          //사업장 그룹사업장 그룹
          this.companyGroupList = response[3].list.slice()
          this.companyGroupNames = new Map(this.companyGroupList.map((obj) => [obj.compId, obj.compNm]))
          this.enrichCompanyGroupDisplay()
        }
      })
    },
    enrichCompanyGroupDisplay() {
      if (!this.gridMain || !this.gridMain.length) return
      this.gridMain.forEach((row) => {
        row.companyGroupDisplay = this.getCompanyGroupDisplayText(row.companyGroup)
      })
    },
    companyGroupFilterExpression(filterValue, selectedFilterOperation) {
      if (!filterValue) return null
      return ['companyGroupDisplay', 'contains', filterValue]
    },
    onCheckValueChanged(event, cellInfo) {
      cellInfo.setValue(event.value ? 'Y' : 'N')
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
    },
    onCompanyGroupValueChanged(value, cellInfo) {
      let val = value.sort()
      const valueStr = val.toString()
      cellInfo.setValue(valueStr)
      if (cellInfo.data) {
        cellInfo.data.companyGroupDisplay = this.getCompanyGroupDisplayText(valueStr)
      }
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
    },
    filterCompanyGroup(item, queryText, itemText) {
      const search = (queryText || '').toString().trim().toLowerCase()
      if (!search) {
        return true
      }

      const targets = [item.compNm, item.clntNm, item.addrs1]
      return targets.some((field) => (field || '').toString().toLowerCase().includes(search))
    },
    getCompanyGroupDisplayText(value) {
      if (!value || !this.companyGroupNames.size) return ''

      return this.companyGroupList
        .filter((item) => value.includes(item.clntId + '_' + item.compId))
        .map((item) => item.compNm)
        .join(', ')
      // const ids = value.toString().split(',').map((s) => s.trim()).filter(Boolean)
      // return ids.map((id) => this.companyGroupNames.get(id) || id).join(', ')
    },
  },
}
</script>

<style lang="scss">
.dx-command-select {
  width: 30px !important;
  min-width: 30px !important;
}
.dropzone-external {
  width: 65px;
  height: 30px;
  background-color: rgba(183, 183, 183, 0.1);
  border-width: 0px;
  padding: 0px;
}

.widget-container > span {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 16px;
}

.dropzone-image {
  max-width: 100%;
  max-height: 100%;
}

.flex-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
}

.widget-container {
  margin-right: 320px;
}

.contents h4 {
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 18px;
}

.contents {
  margin-top: 50px;
  margin-left: 10px;
  display: none;
}

.fileList {
  padding: 10px;
  width: 400px;
  background-color: rgba(183, 183, 183, 0.1);
}

.fileNm {
  height: 20px;
  font-weight: bold;
}

.fileList > .fileSize {
  height: 20px;
  font-size: 12px;
}
.v-select--chips > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections {
  overflow: scroll;
  flex-wrap: nowrap;
}
.v-chip {
  overflow: initial;
}
.company-group-item {
  padding-left: 16px;
  padding-right: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.company-group-grid {
  display: grid;
  grid-template-columns: 1.2fr 1.8fr 1.2fr;
  gap: 8px;
  align-items: center;
}

.company-group-grid.header {
  font-size: 15px;
  font-weight: 600;
  color: #1976d2;
}

.company-group-grid .ellipsis {
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.company-group-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  max-width: 100%;
}

@keyframes guide-blink-red {
  0%,
  100% {
    color: inherit;
    box-shadow: inset 0 0 0 0 transparent;
    outline: 2px solid transparent;
    background-color: transparent;
  }
  50% {
    color: #f44336 !important;
    box-shadow: inset 0 0 0 2px rgba(244, 67, 54, 0.85);
    outline: 2px solid #f44336;
    background-color: rgba(244, 67, 54, 0.12);
  }
}

.guide-highlight-add .btn_btnAdd {
  animation: guide-blink-red 0.8s ease-in-out 5;
  border-radius: 8px;
}

.guide-highlight-add .guide-download-btn .iconBtn {
  animation: guide-blink-red 0.8s ease-in-out 5;
  border-radius: 8px;
}
</style>
